import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { NgApiCommonModule } from '@n3/ng-api-common';
import { NgApiBaseKitModule, BaseService  } from '@n3/ng-api-base-kit';

import { InstitutionService } from '../services/institution.service';

import { TransferEnviromentService } from '../services/transferEnviroment.service';

@NgModule({
    declarations: [
        // Pipes.
        // Directives.
    ],
    exports: [
        // Pipes.
        // Directives.
    ],
    imports: [
        BrowserModule,
        NgApiCommonModule.forRoot(),
        NgApiBaseKitModule.forRoot(),
    ]
})
export class NgApiInstitutionModule {

    /**
     * Use in AppModule
     */
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: NgApiInstitutionModule,
            providers: [
                InstitutionService,
                BaseService,
                TransferEnviromentService
            ]
        };
    }

    /**
     * Use in features modules with lazy loading
     */
    public static forChild(): ModuleWithProviders {
        return {
            ngModule: NgApiInstitutionModule,
            providers: [
                InstitutionService,
                BaseService,
                TransferEnviromentService
            ]
        };
    }

}
